import React, { useEffect, useState, useCallback } from 'react'
import { videoApi } from '@services/api'
import ListVideoComponent from './ListVideoComponent'
import { categoryImages } from './TopMenu'

const limit = 6

const ListVideoByFoodCateGroup: React.FC<any> = ({
  category,
  onSelectVideo
}) => {
  const [firstLoad, setFirstLoad] = useState(false)
  const [videos, setVideos] = useState([] as any[])
  const [page, setPage] = useState(1)
  const [hasNextPage, setHasNextPage] = useState(false)
  const [loading, setLoading] = useState(true)
  const [loadingFalse, setLoadingFalse] = useState(true)

  const fetchVideos = useCallback(async () => {
    try {
      setLoading(true)
      setLoadingFalse(false)
      const params = {
        FoodCateGroupId: category.id,
        PageIndex: page,
        PageSize: limit
      }
      const res = await videoApi.getVideoByFoodCateGroup(params)
      if (res && res.success) {
        setVideos([...videos, ...res.data])
        setHasNextPage(res.hasNextPage)
      }
      setLoading(false)
    } catch (error) {
      setLoadingFalse(true)
      setLoading(false)
    }
  }, [category, page, videos])

  useEffect(() => {
    if (!firstLoad) {
      setFirstLoad(true)
      fetchVideos()
    }
  }, [fetchVideos, firstLoad])

  const onResetListVideo = async () => {
    await setPage(1)
    await fetchVideos()
    setVideos(videos.slice(0, limit))
    setHasNextPage(true)
  }

  const changePage = async (pageIndex: number) => {
    await setPage(pageIndex)
    await fetchVideos()
  }

  return (
    <>
      <ListVideoComponent
        id={`category-${category.id}`}
        videos={videos}
        page={page}
        setPage={changePage}
        hasNextPage={hasNextPage}
        loading={loading}
        title={(
          <>
            <img src={categoryImages[category.name]} className="me-2" height="30" alt={category.name} />
            {category.name === 'その他' ? 'ホテル' : category.name}
          </>
        )}
        onSelectVideo={onSelectVideo}
        onResetListVideo={onResetListVideo}
      />
      {loadingFalse && (
        <span aria-hidden="true" onClick={fetchVideos} className="btn">
          リトライ
        </span>
      )}
    </>
  )
}

export default ListVideoByFoodCateGroup
